module.exports = __webpack_public_path__ + "employees-21b62107/card-blur-03fb4cd6d1a848e16dd09e786bc251df.png";